angular.module('bb.util').factory('UtilService', UtilService);

UtilService.$inject = ['$resource'];
function UtilService($resource) {
  const ListingSearch = $resource('/search/listings');
  // TODO: Search Org here might be deprecated
  const OrgSearch = $resource('/search/orgs');
  const OrgSettings = $resource('/org/settings');
  const ServerDate = $resource('/date');
  const UserSearch = $resource('/user/search');

  function searchListings(input) {
    return ListingSearch.get({ input }).$promise;
  }

  function searchOrgs(input) {
    return OrgSearch.get({ input }).$promise;
  }

  function getOrgSettings() {
    return OrgSettings.get().$promise;
  }

  function getServerDate() {
    return ServerDate.get().$promise;
  }

  const searchRosterUsers = (name, page) =>
    UserSearch.query({ name, page }).$promise;

  return {
    searchListings,
    getServerDate,
    searchOrgs,
    getOrgSettings,
    searchRosterUsers,
  };
}

export {};
